import _extends from "@babel/runtime/helpers/esm/extends";
import spacing from '../../styles/spacing';
export var getStyles = function getStyles(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$externalStyles = _ref.externalStyles,
      externalStyles = _ref$externalStyles === void 0 ? {} : _ref$externalStyles,
      _ref$excludeScrollTra = _ref.excludeScrollTrack,
      excludeScrollTrack = _ref$excludeScrollTra === void 0 ? false : _ref$excludeScrollTra;

  return _extends({
    wrapperStyles: _extends({
      display: 'inline-block',
      minWidth: '100%',
      padding: 0
    }, externalStyles.wrapperStyle),
    pillsListStyles: _extends({
      display: 'inline-block',
      padding: 0,
      marginRight: 4,
      marginLeft: 4
    }, spacing.MARGIN_Y_SM, externalStyles.listStyle)
  }, excludeScrollTrack && {
    pillOverrideStyles: {
      button: {
        marginBottom: 8
      }
    }
  });
};